<template>
  <div>
    <el-dialog
        v-el-drag-dialog
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        :title="materialGroups.pkid > 0 ? '编辑':'新建'"
        class="customer-edit"
        width="500px"
        top="10vh"
        @close="$reset('form')">
      <el-form
          ref="form"
          v-loading="contentLoading"
          :model="materialGroups"
          :rules="ruleValidate"
          class="form"
          label-width="120px">
        <el-form-item label="物料组编号">
          <el-input v-model="materialGroups.materialGroupCode" placeholder="请输入"/>
        </el-form-item>
        <el-form-item label="Mrp控制者">
          <el-input v-model="materialGroups.mrpController" placeholder="请输入"/>
        </el-form-item>
        <el-form-item label="物料组名称">
          <el-input v-model="materialGroups.materialGroupName" placeholder="请输入"/>
        </el-form-item>
        <el-form-item label="其他物料组名称">
          <el-input v-model="materialGroups.materialGroupName1" placeholder="请输入"/>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="materialGroups.status" clearable placeholder="请选择">
            <el-option
                v-for="item in statusText"
                :key="item.value"
                :label="item.label"
                :value="item.value"/>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="dialogVisible=false">取消</el-button>
        <el-button :loading="submitLoading" type="primary" @click="handleSubmit">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import constant from "../../../util/constant";

  export default {
    name:"MaterialGroupConfigEdit",
    components: {},
    data() {
      return {
        constant,
        statusText: constant.toSelect(constant.status),
        dialogVisible: false,
        contentLoading: false,
        submitLoading: false,
        parentNameList: [],
        materialGroups: {
          addDate: "",
          bookerID: "",
          bookerName: "",
          materialGroupCode: "",
          materialGroupDescription: "",
          materialGroupDescription1: "",
          materialGroupName: "",
          materialGroupName1: "",
          mrpController: "",
          ownerID: "",
          ownerName: "",
          pkid: "",
          status: "",
          updateDate: "",
        },
        ruleValidate: {
          districtName: {required: true, message: "不能为空",trigger: "blur"},
          note: {required: true, message: "不能为空",trigger: "blur"},
        },
      };
    },
    methods: {
      open(id) {
        this.materialGroups.pkid = id;
        this.dialogVisible = true;
        if(id>0) {
          this.getData();
        }else {
          this.getNote();
        }
      },
      getData() {
        this.$http
          .get("basic", `materialGroups/${this.materialGroups.pkid}`)
          .then(resp => {
            this.materialGroups = resp;
          });
      },
      getNote() {
        this.$http
          .get("basic", "materialGroups")
          .then(resp => {
            this.materialGroups = resp;
          });
      },
      handleSubmit() {
        if(this.materialGroups.pkid>0) {
          this.handleSubmitUpData();
        }else {
          this.handleSubmitSave();
        }
      },
      handleSubmitUpData() {
        this.$refs.form.validate(valid => {
          if (valid) {
            this.submitLoading = true;
            this.$http
              .put("basic", "materialGroups", this.materialGroups)
              .then(() => {
                this.submitLoading = false;
                this.dialogVisible = false;
                this.$emit("save-success");
                this.$message.success("保存成功");
              })
              .catch(() => {
                this.submitLoading = false;
              });
          }
        });
      },
      handleSubmitSave() {
        this.$refs.form.validate(valid => {
          if (valid) {
            this.submitLoading = true;
            this.$http
              .post("basic", "materialGroups", this.materialGroups)
              .then(() => {
                this.submitLoading = false;
                this.dialogVisible = false;
                this.$emit("save-success");
                this.$message.success("保存成功");
              })
              .catch(() => {
                this.submitLoading = false;
              });
          }
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
</style>
